import { render, staticRenderFns } from "./reversemoney.vue?vue&type=template&id=29000b4a&"
import script from "./reversemoney.vue?vue&type=script&lang=js&"
export * from "./reversemoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports